import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { THEME } from './naTheme';

// ─── Status config (unchanged logic) ─────────────────────────────────────────

const getStatusConfig = (attended_status) => {
  if (attended_status == 1)  return { label: 'Present', bg: 'rgba(16,185,129,0.12)',  color: '#047857', icon: 'fas fa-check-circle',  borderColor: '#10B981' };
  if (attended_status == 0)  return { label: 'Absent',  bg: 'rgba(239,68,68,0.12)',   color: '#B91C1C', icon: 'fas fa-times-circle',  borderColor: '#EF4444' };
  return                     { label: 'Sick',    bg: 'rgba(245,158,11,0.12)',  color: '#B45309', icon: 'fas fa-thermometer-half', borderColor: '#F59E0B' };
};

// ─── Component ────────────────────────────────────────────────────────────────

class DailyAttendanceModal extends Component {
  render() {
    const { stateData, show, onHide } = this.props;

    return (
      <Modal show={show} onHide={onHide} size="md" centered aria-labelledby="daily-attendance-modal">
        {/* ── Header ─────────────────────────────────────────────────── */}
        <Modal.Header
          closeButton
          style={{
            background:   THEME.gradient,
            border:       'none',
            borderRadius: '12px 12px 0 0',
            padding:      '16px 20px',
          }}
        >
          <Modal.Title id="daily-attendance-modal" style={{ color: '#fff', fontWeight: 700, fontSize: '16px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <i className="fas fa-calendar-day" />
            Day-wise Attendance
          </Modal.Title>
        </Modal.Header>

        {/* ── Body ───────────────────────────────────────────────────── */}
        <Modal.Body style={{ padding: '20px', background: '#F9FAFB', borderRadius: '0 0 12px 12px' }}>

          {stateData.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '24px', color: '#6B7280' }}>
              <i className="fas fa-calendar-times" style={{ fontSize: '32px', marginBottom: '10px', display: 'block', color: '#D1D5DB' }} />
              <p style={{ margin: 0, fontSize: '14px' }}>No attendance data for this day.</p>
            </div>
          ) : (
            stateData.map((item, idx) => {
              const cfg = getStatusConfig(item.attended_status);
              return (
                <div
                  key={idx}
                  style={{
                    display:       'flex',
                    alignItems:    'center',
                    justifyContent: 'space-between',
                    background:    '#fff',
                    border:        `1px solid ${cfg.borderColor}22`,
                    borderLeft:    `4px solid ${cfg.borderColor}`,
                    borderRadius:  '10px',
                    padding:       '12px 16px',
                    marginBottom:  idx < stateData.length - 1 ? '10px' : '0',
                    boxShadow:     '0 1px 3px rgba(0,0,0,0.05)',
                  }}
                >
                  {/* Attendance type */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{
                      width:        '36px',
                      height:       '36px',
                      borderRadius: '50%',
                      background:   cfg.bg,
                      display:      'flex',
                      alignItems:   'center',
                      justifyContent: 'center',
                    }}>
                      <i className={cfg.icon} style={{ color: cfg.color, fontSize: '14px' }} />
                    </div>
                    <span style={{ fontSize: '14px', fontWeight: 500, color: '#111827' }}>
                      {item.attendance_type}
                    </span>
                  </div>

                  {/* Status badge */}
                  <span style={{
                    background:   cfg.bg,
                    color:        cfg.color,
                    padding:      '4px 14px',
                    borderRadius: '20px',
                    fontSize:     '12px',
                    fontWeight:   700,
                    display:      'inline-flex',
                    alignItems:   'center',
                    gap:          '5px',
                  }}>
                    <i className={cfg.icon} style={{ fontSize: '11px' }} />
                    {cfg.label}
                  </span>
                </div>
              );
            })
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

export default DailyAttendanceModal;
